// TODO fix direct import from `@tanstack/react-query`
import { type InfiniteData, useQueryClient } from '@tanstack/react-query';
import { type UserRSVP, type PaginationData } from 'models';
import { type QueryKey } from 'query';
import { type Todo } from 'features/todos/types';
import { getTodosQueryKey } from '..';

export const useUpdateEventTodos = () => {
  const queryClient = useQueryClient();

  const setUserRSVP = ({ todo, eventId, userRSVP }: { todo: Todo; eventId: string; userRSVP: UserRSVP }) => {
    if (todo.type === 'Event' && todo.event.id === eventId) {
      return {
        ...todo,
        event: {
          ...todo.event,
          currentUserRsvp: userRSVP,
        },
      };
    }

    return todo;
  };

  const updateEventData = ({
    queryKey,
    eventId,
    userRSVP,
  }: {
    queryKey: QueryKey;
    eventId: string;
    userRSVP: UserRSVP;
  }) => {
    queryClient.setQueriesData<InfiniteData<PaginationData<Todo>>>(
      {
        queryKey,
        exact: false,
      },
      (data) => {
        if (!data) return;

        return {
          ...data,
          pages: data.pages.map((page) => ({
            ...page,
            data: page.data.map((todo) => setUserRSVP({ todo, eventId, userRSVP })),
          })),
        };
      },
    );
  };

  const removeEventData = ({ queryKey, eventId }: { queryKey: QueryKey; eventId: string }) => {
    queryClient.setQueriesData<InfiniteData<PaginationData<Todo>>>(
      {
        queryKey,
        exact: false,
      },
      (data) => {
        let wasRemoved = false;

        if (!data) return;

        for (const page of data.pages) {
          const index = page.data.findIndex((item) => item.type === 'Event' && item.event.id === eventId);
          if (index !== -1) {
            page.data.splice(index, 1);
            wasRemoved = true;

            break;
          }
        }

        if (wasRemoved) {
          for (const page of data.pages) {
            page.total -= 1;
          }
        }

        return data;
      },
    );
  };

  const updateEventTodos = ({ eventId, statusToApply }: { eventId: string; statusToApply: UserRSVP }) => {
    switch (statusToApply) {
      case 'going':
      case 'pending':
        return updateEventData({ queryKey: getTodosQueryKey({}), eventId, userRSVP: statusToApply });
      case 'not_going':
        return removeEventData({ queryKey: getTodosQueryKey({}), eventId });
    }
  };

  return { updateEventTodos };
};
